<template>
<div>

    <wewHeader></wewHeader>

    <wewSteps v-bind:stepActive="3"></wewSteps>

    <section class="step-3 pad-t-90 pad-b-80" style="background: #EFEFEF;margin-top:-100px;">

        <div class="container">
            <h1 class="text-center">TELL US A LITTLE BIT MORE ABOUT<br>YOUR <span class="color-blue">{{ submission.make }} {{ submission.model }}</span></h1>
            <form class="car-details-form" @submit.prevent="validateBeforeSubmit('step4')">
                
                    <div class="pad-t-40 pad-lr-md-40 pad-lr-lg-80 pad-lr-xl-120">
                        
                        <div class="question">
                            <div class="q-title">Mileage</div>
                            <div class="q-field">
                                <textbox v-bind:textbox="mileage" v-model="submission.condition.mileage"></textbox>
                                <div :class="[formSubmitted && payload.mileageType==null ? 'buttons-error-msg' : '']">
                                    <input-button v-bind:inputButton="mileageType.button1" v-bind:buttonSelected="mileageTypeSelected" v-on:changeButton="changeButtonMileageType"></input-button>
                                    <input-button v-bind:inputButton="mileageType.button2" v-bind:buttonSelected="mileageTypeSelected" v-on:changeButton="changeButtonMileageType"></input-button>  
                                </div>
                            </div>
                        </div>

                        <div class="question marg-b-10">
                            <div class="q-title">Rating</div>
                            <div class="q-field">
                                <star-rating v-model="payload.rating" 
                                    :show-rating="false" 
                                    @current-rating="showRatingDescription($event)"
                                    :rounded-corners="true" 
                                    :star-size="40"
                                    :active-color="'#29AAE5'"
                                    :padding="15"></star-rating>
                            </div>
                              
                        </div>
                        <p class="rating-description marg-b-30">{{ ratingDescription }}</p>

                        <div class="question top">
                            <div class="q-title">Description</div>
                            <div class="q-field">
                                <input-textarea v-bind:textboxArea="description" v-model="submission.condition.description"></input-textarea>
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Service History</div>
                            <div :class="[formSubmitted && payload.serviceHistory==null ? 'buttons-error-msg' : '', 'q-field']">
                                <input-button v-bind:inputButton="serviceHistory.button1" v-bind:buttonSelected="serviceHistorySelected" v-on:changeButton="changeButtonServiceHistory"></input-button>
                                <input-button v-bind:inputButton="serviceHistory.button2" v-bind:buttonSelected="serviceHistorySelected" v-on:changeButton="changeButtonServiceHistory"></input-button>      
                                <input-button v-bind:inputButton="serviceHistory.button3" v-bind:buttonSelected="serviceHistorySelected" v-on:changeButton="changeButtonServiceHistory"></input-button>    
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Spare Key</div>
                            <div :class="[formSubmitted && payload.spareKey==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="spareKey.button1" v-bind:buttonSelected="spareKeySelected" v-on:changeButton="changeButtonSpareKey"></input-button>
                                <input-button v-bind:inputButton="spareKey.button2" v-bind:buttonSelected="spareKeySelected" v-on:changeButton="changeButtonSpareKey"></input-button>      
                           </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Spare Tyre</div>
                            <div :class="[formSubmitted && payload.spareTyre==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="spareTyre.button1" v-bind:buttonSelected="spareTyreSelected" v-on:changeButton="changeButtonSpareTyre"></input-button>
                                <input-button v-bind:inputButton="spareTyre.button2" v-bind:buttonSelected="spareTyreSelected" v-on:changeButton="changeButtonSpareTyre"></input-button>      
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Tyres Good</div>
                            <div :class="[formSubmitted && payload.tyresLegal==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="tyresLegal.button1" v-bind:buttonSelected="tyresLegalSelected" v-on:changeButton="changeButtonTyresLegal"></input-button>
                                <input-button v-bind:inputButton="tyresLegal.button2" v-bind:buttonSelected="tyresLegalSelected" v-on:changeButton="changeButtonTyresLegal"></input-button>      
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Windscreen Damage</div>
                            <div :class="[formSubmitted && payload.windscreenDamage==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="windscreenDamage.button1" v-bind:buttonSelected="windscreenDamageSelected" v-on:changeButton="changeButtonWindscreenDamage"></input-button>
                                <input-button v-bind:inputButton="windscreenDamage.button2" v-bind:buttonSelected="windscreenDamageSelected" v-on:changeButton="changeButtonWindscreenDamage"></input-button>      
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Used as a Taxi</div>
                            <div :class="[formSubmitted && payload.usedAsTaxi==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="usedAsTaxi.button1" v-bind:buttonSelected="usedAsTaxiSelected" v-on:changeButton="changeButtonUsedAsTaxi"></input-button>
                                <input-button v-bind:inputButton="usedAsTaxi.button2" v-bind:buttonSelected="usedAsTaxiSelected" v-on:changeButton="changeButtonUsedAsTaxi"></input-button>      
                            </div>
                        </div>

                        <div class="question">
                            <div class="q-title">Finance Outstanding</div>
                            <div :class="[formSubmitted && payload.financeOutstanding==null ? 'buttons-error-msg' : '', 'q-field']">
                               <input-button v-bind:inputButton="financeOutstanding.button1" v-bind:buttonSelected="financeOutstandingSelected" v-on:changeButton="changeButtonFinanceOutstanding"></input-button>
                                <input-button v-bind:inputButton="financeOutstanding.button2" v-bind:buttonSelected="financeOutstandingSelected" v-on:changeButton="changeButtonFinanceOutstanding"></input-button>      
                            </div>
                        </div>

                            
                        
                    </div>
                
                <div class="text-center pad-t-40">
                    <button type="submit" class="m4c-btn color-white marg-r-10 marg-t-10"><span class="v-top">LAST STEP</span></button>
                </div>
            </form>
        </div>

    </section>

    <wewFooterWhite></wewFooterWhite>
</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewSteps from '@/components/Steps'
import textbox from '@/components/input-text'
import inputButton from '@/components/input-button'
import inputTextarea from '@/components/input-textarea'
import StarRating from 'vue-star-rating'
import wewFooterWhite from '@/components/wew-footer-white'

export default {
    name: 'step3',
    components: {
        wewHeader,
        wewSteps,
        textbox,
        inputButton,
        inputTextarea,
        StarRating,
        wewFooterWhite
    },
 data() {
        return {
            formSubmitted: false,
            payload: {
                rating: null,
                mileageType: null,
                serviceHistory: null,
                spareKey: null,
                spareTyre: null,
                tyresLegal: null,
                windscreenDamage: null,
                usedAsTaxi: null,
                financeOutstanding: null
            },
            ratingDescription: '',
            description: {
                id: 'description',
                class: 'm4c-textarea',
                name: 'description',
                placeholder: 'Any further relevant information about this vehicle',
                helpText: '',
                errorMsgName: 'Description',
                veeRules: 'max:250',
                value: ''
            },
            mileage: {
                name: 'Mileage',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:6|numeric',
                value: null
            },
            mileageType: {
                button1: {
                    id: "selectMileageType1",
                    class: "",
                    name: "selectMileage",
                    label: "Miles",
                    style: "radio",
                    value: 'miles'
                },
                button2: {
                    id: "selectMileageType2",
                    class: "",
                    name: "selectMileage",
                    label: "KM",
                    style: "radio",
                    value: 'km'
                },
            },
            mileageTypeSelected: null,

            serviceHistory: {
                button1: {
                    id: "selectServiceHistory1",
                    class: "",
                    name: "selectServiceHistory",
                    label: "Full",
                    style: "radio",
                    value: 'full'
                },
                button2: {
                    id: "selectServiceHistory2",
                    class: "",
                    name: "selectServiceHistory",
                    label: "Partial",
                    style: "radio",
                    value: 'partial'
                },
                button3: {
                    id: "selectServiceHistory3",
                    class: "",
                    name: "selectServiceHistory",
                    label: "None",
                    style: "radio",
                    value: 'none'
                },
            },
            serviceHistorySelected: null,

            spareKey: {
                button1: {
                    id: "selectSpareKey1",
                    class: "",
                    name: "selectSpareKey",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectSpareKey2",
                    class: "",
                    name: "selectSpareKey",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            spareKeySelected: null,

            spareTyre: {
                button1: {
                    id: "selectSpareTyre1",
                    class: "",
                    name: "selectSpareTyre",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectSpareTyre2",
                    class: "",
                    name: "selectSpareTyre",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            spareTyreSelected: null,

            tyresLegal: {
                button1: {
                    id: "selectTyresLegal1",
                    class: "",
                    name: "selectTyresLegal",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectTyresLegal2",
                    class: "",
                    name: "selectTyresLegal",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            tyresLegalSelected: null,

            windscreenDamage: {
                button1: {
                    id: "selectWindscreenDamage1",
                    class: "",
                    name: "selectWindscreenDamage",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectWindscreenDamage2",
                    class: "",
                    name: "selectWindscreenDamage",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            windscreenDamageSelected: null,

            usedAsTaxi: {
                button1: {
                    id: "selectUsedAsTaxi1",
                    class: "",
                    name: "selectUsedAsTaxi",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectUsedAsTaxi2",
                    class: "",
                    name: "selectUsedAsTaxi",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            usedAsTaxiSelected: null,

            financeOutstanding: {
                button1: {
                    id: "selectFinanceOutstanding1",
                    class: "",
                    name: "selectFinanceOutstanding",
                    label: "Yes",
                    style: "radio",
                    value: true
                },
                button2: {
                    id: "selectFinanceOutstanding2",
                    class: "",
                    name: "selectFinanceOutstanding",
                    label: "No",
                    style: "radio",
                    value: false
                },
            },
            financeOutstandingSelected: null,
        }
    },
computed: {
    submission() {
      return this.$store.getters.submission
    },
    allFieldsFilled() {
        
        if(
            this.mileageTypeSelected!==null &&
            this.serviceHistorySelected!==null &&
            this.spareKeySelected!==null &&
            this.spareTyreSelected!==null &&
            this.tyresLegalSelected!==null &&
            this.windscreenDamageSelected!==null &&
            this.usedAsTaxiSelected!==null &&
            this.financeOutstandingSelected!==null &&
            this.errors.items.length===0
        ) {
            return true
        } else {
            return false
        }

    }
  },
methods: {
    showRatingDescription(rating) {
        this.ratingDescription = this.submission.ratingDescriptions[rating]
    },
    changeButtonMileageType(value){
        this.mileageTypeSelected = value //to highlight button
        this.payload.mileageType = value
        //this.submission.condition.mileageType = value
    },

    changeButtonServiceHistory(value){
        this.serviceHistorySelected = value
        this.payload.serviceHistory = value
        //this.submission.condition.serviceHistory = value
    },

    changeButtonSpareKey(value){
        this.spareKeySelected = value
        this.payload.spareKey= value
        //this.submission.condition.spareKey = value
    },

    changeButtonSpareTyre(value){
        this.spareTyreSelected = value
        this.payload.spareTyre = value
        //this.submission.condition.spareTyre = value
    },

    changeButtonTyresLegal(value){
        this.tyresLegalSelected = value
        this.payload.tyresLegal = value
        //this.submission.condition.tyresLegal = value
    },

    changeButtonWindscreenDamage(value){
        this.windscreenDamageSelected = value
        this.payload.windscreenDamage = value
        //this.submission.condition.windscreenDamage = value
    },

    changeButtonUsedAsTaxi(value){
        this.usedAsTaxiSelected = value
        this.payload.usedAsTaxi = value
        //this.submission.condition.usedAsTaxi = value
    },

    changeButtonFinanceOutstanding(value){
        this.financeOutstandingSelected = value
        this.payload.financeOutstanding = value
        //this.submission.condition.financeOutstanding = value
    },

    validateBeforeSubmit(route) {
        this.formSubmitted = true
        this.$validator.validateAll().then((valid) => {
            if(valid){
                if(this.allFieldsFilled) {
                    //Get the buttons and star rating data from payload
                    let condition = this.payload
                    //textarea & textinput treated in the normal way with .value
                    condition.mileage = this.mileage.value
                    condition.description = this.description.value

                    this.$store.dispatch('storeVehicleCondition', condition)
                    this.$router.push(route)
                } 
            }
        })
        
    }
}
}
</script>

<style>
.buttons-error-msg{
    position: relative;
    border: 1px solid red;
    border-radius: 100px;

}
.buttons-error-msg::after{
    position: absolute;
    bottom: -25px;
    left: 12px;
    color: red;
    content: "required field"
}

.step-3 h1{
    font-size: 38px;
    line-height: 38px;
    text-transform: uppercase;
    
}

h2.car-title{
    text-transform: uppercase;
    font-size: 40px;
    line-height: 40px;
}

.reg-title{
    background:#CCCCCC;
    border-radius: 30px;
    padding: 2px 18px;
    display: inline-block;
    font-size: 18px;
    font-weight:800;
}

.rating-description {
    font-size: 21px;
    font-weight: 400;
    line-height:24px;
    height: 80px;
}
</style>
